import { forwardRef, memo, MouseEvent as ReactMouseEvent } from "react";
import classnames from "classnames";

import { ReactComponent as Cross } from "./images/error.svg";

import styles from "./style.module.scss";

type ErrorButtonProps = {
  onClick?: (e: ReactMouseEvent<HTMLButtonElement, MouseEvent>) => void,
  className?: string,
  disabled?: boolean
}

const ErrorButton = memo<ErrorButtonProps>(forwardRef<HTMLButtonElement, ErrorButtonProps>(((props, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      className={classnames(styles.root, props.className)}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      <Cross width={16} height={16} />
    </button>
  );
})));

export default ErrorButton;
